import { render } from "./AppButton.vue?vue&type=template&id=6b44bbfd&scoped=true&lang=pug"
import script from "./AppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=6b44bbfd&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b44bbfd"]])

export default __exports__